/* ********************************
 *     Data States & Templates
 * ********************************
 */

 /* eslint-disable no-unused-vars */
import Vue from 'vue';
import _store from "@/store";

import template from "./data-template";

export { _store as store };

export const state = {

  // States from Vuex store (Read only, don't mutate directly)
  store: _store.state,
  
  // Setup local state here (States which don't shared or long-term keeping);
  local: Vue.observable({
    // Contain list of Examinations.
    list: [],
    
    // Contain configs of internal editor.
    editor: { active: false },

    // Form: Contain form input.
    form: { ...template.form },
    
    // Filter Selection: Contain filter selection states (flatted);
    filterSelection: {
      academicPeriod: null,
      degree: null,
      subjectGroup: null,
      subject: null,
      teacher: null
    },
    
    // Loading: Contain loading state for each subcomponent.
    loading: {
      list: true
    },

    // Status for each subcomponent
    status: {
      list: {
        active: false,
        message: ""
      }
    },

    // Options for specific selector. 
    selectorOptions: {
      subject: [],
      courseOutline: []
    }
  })
};
